import {
  Box,
  Button,
  calc,
  Center,
  Flex,
  Heading,
  Image,
  Text,
} from '@chakra-ui/react'
import React, {useCallback} from 'react'
import {BsArrowRight} from 'react-icons/bs'
import {getConnectionUrl} from '../../Api/user'
import AuthenticatedRoutes from '../../Utils/AuthenticatedRoutes'
import NavbarOpen from '../NavLinks/NavbarOpen'
import './auth.css'

const Login = () => {
  const getConnectionUrlHandler = useCallback(async () => {
    const apiResponse = await getConnectionUrl(window.location.href)
    if (apiResponse?.url) {
      window.open(apiResponse.url, '_blank')
    }
  }, [])
  return (
    <Box h='100vh'>
      <NavbarOpen />
      <Box>
        <AuthenticatedRoutes auth={false} />
        <Box>
          <Flex justify='center'>
            <Center w='50%' color='black' h='calc(100vh - 70px)' align='center'>
              <Box mt='-60px'>
                <Heading
                  fontSize='5xl'
                  color='black'
                  px='150px'
                  lineHeight='1'
                  mb='40px'
                >
                  <Box bg='#A423A9' display='inline' px={2} color='white'>
                    Supercharge
                  </Box>{' '}
                  your next meeting
                </Heading>
                <Text color='black' mb='42px'>
                  By signing up, I agree to Arrowhead’s{' '}
                  <Text as='span' color='#5952E4' textDecoration='underline'>
                    Terms{' '}
                  </Text>
                  and{' '}
                  <Text as='span' color='#5952E4' textDecoration='underline'>
                    Privacy Policy
                  </Text>
                  .
                </Text>
                <Button
                  bg='black'
                  _hover={{bg: 'black'}}
                  px='30px'
                  onClick={getConnectionUrlHandler}
                >
                  <Flex align='center'>
                    <Box mr={2}>
                      <Image src='/assets/icons/google.svg' boxSize={4} />{' '}
                    </Box>
                    <Text fontSize='md'>Continue with Google</Text>
                  </Flex>
                </Button>
              </Box>
            </Center>
            <Center w='50%' bg='#E2D7F5' h='calc(100vh - 70px)' align='center'>
              <Box mt='-75px'>
                <Image
                  borderRadius='full'
                  boxSize='100px'
                  src='https://bit.ly/dan-abramov'
                  bg='white'
                  objectFit='cover'
                  mb='34px'
                />
                <Text color='black' px='200px' fontWeight={500} fontSize='21px'>
                  “A great tool for capturing and sharing customer feedback!”
                </Text>
              </Box>
            </Center>
          </Flex>
        </Box>
      </Box>
    </Box>
  )
}

export default Login
